// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as AuthUtils$PorterinFeature from "./AuthUtils.mjs";
import * as AuthRepoManager$PorterinFeature from "../repo/AuthRepoManager.mjs";

function customerOtpValidation(web_tracking_id, user, otp, agreed_docs, referral_code, geo_region_id, on_success, on_failure) {
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry.app(RepoInstance.validateOtp, [
                      web_tracking_id,
                      AuthUtils$PorterinFeature.mobile(user),
                      AuthUtils$PorterinFeature.email(user),
                      otp,
                      AuthUtils$PorterinFeature.name(user),
                      AuthUtils$PorterinFeature.whatsappConsent(user),
                      AuthUtils$PorterinFeature.requirementType(user),
                      agreed_docs,
                      referral_code,
                      geo_region_id
                    ]);
        }), Curry.__1(on_success), Curry.__1(on_failure));
}

export {
  customerOtpValidation ,
}
/* AuthRepoManager-PorterinFeature Not a pure module */
